import { put, call } from "redux-saga/effects";
import { SAVE_AAROLES_COMPLETED,SAVE_AAROLES_FAILED,GET_AAROLES_FAILED,GET_AAROLES_COMPLETED,DELETE_AAROLES_COMPLETED,DELETE_AAROLES_FAILED} from "../actions/Aaroles";
import {aarolesAPI} from '../../utils/api/AarolesAPI';
export function* saveAaroles(request: any) {
     
    try {
       
         const result=yield call(aarolesAPI.saveAaroles, request.input);
  
        yield put({ 
            type: SAVE_AAROLES_COMPLETED,     
            payload: result.data,
            input: request.input
        });
    } catch (e) {
        yield put({ type: SAVE_AAROLES_FAILED, payload: e.message });
    }
}

export function* getAaroles(request: any) {
    try {
      const result = yield call(aarolesAPI.getAaroles,request.input);
 
   //   var status = result.data;
     
          yield put({
              type: GET_AAROLES_COMPLETED,
              payload: result.data,
              input: request.input
          });        
          
      } catch (e) {        
          yield put({ type: GET_AAROLES_FAILED, payload: e.message });
      }
  }

  export function* deleteAaroles(request: any) {
    try {
      const result = yield call(aarolesAPI.DeleteAaroles,request.input);
    
     // var status = result.data;
     
          yield put({
              type: DELETE_AAROLES_COMPLETED,
              payload: result.data,
              input: request.input
          });        
          
      } catch (e) {        
          yield put({ type: DELETE_AAROLES_FAILED, payload: e.message });
      }
  }
